import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["patientIdInput", "errorMessageTelephone"];

  connect() {
    this.patientIdInputTarget.addEventListener('selected-patient', ({patient}) => {
      const classlist = this.errorMessageTelephoneTarget.classList;
      !patient.cellphone ? classlist.remove('tw-hidden') : classlist.add('tw-hidden');
    })
  }
}
